import type { OrganizationRepository } from '#/domain/organization/OrganizationRepository'

export class DeleteOrganizationUseCase {
  constructor(private readonly repository: OrganizationRepository) {}

  async execute(id: string): Promise<void> {
    return this.repository.remove(id)
  }
}
